import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";
import {formatQueryParams} from "../../util/queryParams";

export const getNewsService = async params => {
  const queryString = formatQueryParams([params]);
  return privateRequest.get(`${ConfEnv.BASE_URL}/blog/articles${queryString}`);
};
